import httpCommon from "@/http-common";

class ManagerRecognitionService {
  getSchools() {
    return httpCommon.get("/admin/recognition-manager/school");
  }

  getDevicesBySchool(idSchool) {
    return httpCommon.get("/admin/recognition-manager/device", {
      params: { idSchool }
    });
  }

  startSynchronizationJob(data) { return httpCommon.post('/admin/recognition-manager/synchronization-jobs', data, { timeout: 15000 }); }
  getSynchronizationJobs() { return httpCommon.get('/admin/recognition-manager/synchronization-jobs', { timeout: 15000 }); }
  getSynchronizationJob(id) { return httpCommon.get('/admin/recognition-manager/synchronization-jobs/' + encodeURIComponent(id), { timeout: 15000 }); }

  synchronizeDevices(data) {
    return httpCommon.post("/admin/recognition-manager/synchronize", data);
  }

  search(idSchool, idDevice, typeAccount, query, page, size) {
    const params = {
      page: page != null ? page : 0,
      size: size != null ? size : 20
    };
    if (idSchool !== "" && idSchool !== null && idSchool !== undefined) {
      params.idSchool = idSchool;
    }
    if (idDevice !== "" && idDevice !== null && idDevice !== undefined) {
      params.idDevice = idDevice;
    }
    if (typeAccount) {
      params.typeAccount = typeAccount;
    }
    if (query && query.trim()) {
      params.query = query.trim();
    }

    return httpCommon.get("/admin/recognition-manager/search", { params });
  }
}

export default new ManagerRecognitionService();

